module.exports = __webpack_public_path__ + "static/key-peices2-3fb1fb12e5263ce947bc63af2b08fd84.png";